export default function getCroppedImg(imageSrc, pixelCrop, originalFileName = "cropped.jpg") {
    return new Promise((resolve, reject) => {
        const image = new window.Image();
        image.src = imageSrc;
        image.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = pixelCrop.width;
            canvas.height = pixelCrop.height;
            const ctx = canvas.getContext("2d");

            ctx.drawImage(
                image,
                pixelCrop.x,
                pixelCrop.y,
                pixelCrop.width,
                pixelCrop.height,
                0,
                0,
                pixelCrop.width,
                pixelCrop.height
            );

            canvas.toBlob((blob) => {
                if (blob) {
                    const file = new File([blob], originalFileName, { type: "image/jpeg" });
                    resolve(file);
                } else {
                    reject(new Error("Canvas is empty"));
                }
            }, "image/jpeg");
        };
        image.onerror = reject;
    });
}